export const SET_DATA = 'bulkScoring/setData'
export const SET_LOADING = 'bulkScoring/setLoading'
export const RESET_TAB = 'bulkScoring/resetTab'

export const setData = (section, payload) => ({ type: SET_DATA, section, payload })
export const setLoading = (section, payload) => ({ type: SET_LOADING, section, payload })
export const resetTab = (tab) => ({ type: RESET_TAB, tab })

const scoreKeys = ['scorePreview', 'scoreJobStatus', 'scoreJobId']
const rescoreKeys = ['rescorePreview', 'rescoreJobStatus', 'rescoreJobId', 'scorecardConfig']

export const initialState = {
  data: {
    scorecardConfig: null,
    scorePreview: null,
    rescorePreview: null,
    scoreJobStatus: null,
    rescoreJobStatus: null,
    scoreJobId: null,
    rescoreJobId: null,
  },
  loading: {
    scorecardConfig: false,
    scorePreview: false,
    rescorePreview: false,
    scoreSubmitting: false,
    rescoreSubmitting: false,
  },
}

export default function bulkScoringReducer(state = initialState, action) {
  switch (action.type) {
    case SET_DATA:
      return { ...state, data: { ...state.data, [action.section]: action.payload } }
    case SET_LOADING:
      return { ...state, loading: { ...state.loading, [action.section]: action.payload } }
    case RESET_TAB: {
      const keys = action.tab === 'score' ? scoreKeys : rescoreKeys
      const resetData = {}
      keys.forEach((key) => {
        resetData[key] = initialState.data[key]
      })
      return { ...state, data: { ...state.data, ...resetData } }
    }
    default:
      return state
  }
}
